import { z } from 'zod'

export const ConfigurationSupportSlackZod = z.object({
  enabled: z.boolean().nullish(),
  channelId: z.string().nullish(),
})
export type ConfigurationSupportSlack = z.infer<typeof ConfigurationSupportSlackZod>
